import React,{ useEffect, useState } from 'react';
import { queuedApiFetch } from '../api';

function RVWSDashboard() {
    const [powerBiUrl, setPowerBiUrl] = useState('');
    const url_name='RVWS_Dashboard';
    const projectDetails = localStorage.getItem("projectDetails");
  const selectedProjectDetail = projectDetails ? JSON.parse(projectDetails) : null;
  const projectName = selectedProjectDetail?.projectName?.trim() || "";

    useEffect(() => {
        const fetchData = async () => {
            try {
                const requestOptions = { method: 'GET' };
                const data = await queuedApiFetch(
                    `/project/get_powerbi_url?url_name=${url_name}`,
                    requestOptions
                );

                if (
                    data?.apistatus?.Status_Code === 200 &&
                    data?.apistatus?.Status_Description?.toLowerCase() === 'success'
                ) {
                    const proj_rvw_dash_url=`${data.data}&filter=T_master_project/Proj_Name%20eq%20%27${projectName}%27&filterPaneEnabled=false&navContentPaneEnabled=false%22`;
                    setPowerBiUrl(proj_rvw_dash_url);
                    // setPowerBiUrl(data.data); 
                } else {
                    console.error('Failed to load Power BI URL');
                }
            } catch (err) {
                console.error('Error fetching data:', err);
            } 
        };

        fetchData();
    }, []);


    return (

        <iframe title="Power BI Report" src={powerBiUrl} sandbox="allow-scripts allow-same-origin allow-forms allow-popups" allowFullScreen></iframe>

    );
}

export default RVWSDashboard;

// import React from 'react';

// function RVWSDashboard() {
//   // const powerBiUrl = "https://app.powerbi.com/view?r=eyJrIjoiODZjNDU4YWQtMThmMC00NWQyLWFlZTgtN2M1MGU1MjkxZTc3IiwidCI6ImIxNjFjODk3LTBhZTItNDJhMC1iZTg2LThmN2UzNmYyMDQ5ZiJ9";
  
//   //const powerBiUrl = process.env.REACT_APP_RVWS_Dashboard; //latest

//   const projectDetails = localStorage.getItem("projectDetails");
//   const selectedProjectDetail = projectDetails ? JSON.parse(projectDetails) : null;
//   const projectName = selectedProjectDetail?.projectName?.trim() || "";

//   // const powerbi_url=`https://app.powerbi.com/reportEmbed?reportId=a4002dd0-01c8-4e28-954a-d14b8d17e5ca&autoAuth=true&ctid=b161c897-0ae2-42a0-be86-8f7e36f2049f&filter=T_master_project/Proj_Name%20eq%20%27${projectName}%27&filterPaneEnabled=false&navContentPaneEnabled=false%22`;

//   // const powerbi_url=`https://app.powerbi.com/reportEmbed?reportId=a164a6ed-020c-4155-a1db-32bedb00268a&autoAuth=true&ctid=5ba5ef5e-3109-4e77-85bd-cfeb0d347e82&filter=T_master_project/Proj_Name%20eq%20%27${projectName}%27&filterPaneEnabled=false&navContentPaneEnabled=false%22`;

//   // const powerbi_url=`https://app.powerbi.com/reportEmbed?reportId=a164a6ed-020c-4155-a1db-32bedb00268a&autoAuth=true&ctid=5ba5ef5e-3109-4e77-85bd-cfeb0d347e82&filter=T_master_project/Proj_Name%20eq%20%27${projectName}%27&filterPaneEnabled=false&navContentPaneEnabled=false%22`;

//   const powerbi_url=`https://app.powerbi.com/reportEmbed?reportId=3c8a030e-7f4d-43af-9163-53c18b693f01&autoAuth=true&ctid=5ba5ef5e-3109-4e77-85bd-cfeb0d347e82&filter=T_master_project/Proj_Name%20eq%20%27${projectName}%27&filterPaneEnabled=false&navContentPaneEnabled=false%22`;

//   //const powerbi_url=`https://app.powerbi.com/reportEmbed?reportId=3c8a030e-7f4d-43af-9163-53c18b693f01&autoAuth=true&ctid=5ba5ef5e-3109-4e77-85bd-cfeb0d347e82`;

//   return (
    
//     //   <iframe  title="Power BI Report"  src={powerBiUrl}  sandbox="allow-scripts allow-same-origin allow-forms allow-popups" allowFullScreen></iframe>

//     <iframe title="Project-RVWS Status" width="1140" height="541.25" src={powerbi_url} frameborder="0" allowFullScreen="true" sandbox="allow-scripts allow-same-origin allow-forms allow-popups" referrerpolicy="strict-origin-when-cross-origin"> </iframe>

//   );
// }

// export default  RVWSDashboard;



// import React, { useEffect, useRef, useState } from "react";
// import * as powerbi from "powerbi-client";
// import { queuedApiFetch } from "../api";

// const RVWSDashboard = () => {
//   const reportContainerRef = useRef(null);
//   const [embedConfig, setEmbedConfig] = useState(null);
//   const [report, setReport] = useState(null);

//   const projectDetails = localStorage.getItem("projectDetails");
//   const selectedProjectDetail = projectDetails ? JSON.parse(projectDetails) : null;
//   const projectName = selectedProjectDetail?.projectName?.trim() || "";

//   useEffect(() => {
//     const fetchEmbedInfo = async () => {
//       try {
//         const response = await queuedApiFetch(`/project/get_project_powerbi_details`, { method: "GET" });

//         if (
//           response?.apistatus?.Status_Code === 200 &&
//           response?.apistatus?.Status_Description?.toLowerCase() === "success" &&
//           response?.data?.embed_url &&
//           response?.data?.access_token &&
//           response?.data?.report_id
//         ) {
//           setEmbedConfig({
//             type: "report",
//             id: response.data.report_id,
//             embedUrl: response.data.embed_url,
//             accessToken: response.data.access_token,
//             tokenType: powerbi.models.TokenType.Embed,
//             permissions: powerbi.models.Permissions.All,
//             settings: {
//               filterPaneEnabled: false,
//               navContentPaneEnabled: false,
//             },
//           });
//         } else {
//           console.error("Invalid Power BI embed response", response);
//         }
//       } catch (err) {
//         console.error("Error fetching embed info:", err);
//       }
//     };

//     fetchEmbedInfo();
//   }, []);

//   useEffect(() => {
//     if (!embedConfig || !reportContainerRef.current) return;

//     const powerbiService = new powerbi.service.Service(
//       powerbi.factories.hpmFactory,
//       powerbi.factories.wpmpFactory,
//       powerbi.factories.routerFactory
//     );

//     // Reset container safely before embedding
//     try {
//       powerbiService.reset(reportContainerRef.current);
//     } catch (e) {
//       console.warn("Skip reset — container not ready");
//     }

//     const embeddedReport = powerbiService.embed(reportContainerRef.current, embedConfig);
//     setReport(embeddedReport);

//     embeddedReport.on("loaded", async () => {
//       console.log("Power BI Report loaded");
//       await applyFilter(embeddedReport);
//     });

//     embeddedReport.on("error", (event) => console.error("Embed error:", event.detail));

//     // Cleanup safely
//     return () => {
//       try {
//         if (reportContainerRef.current) {
//           powerbiService.reset(reportContainerRef.current);
//           console.log("Cleaned up Power BI embed safely");
//         }
//       } catch (e) {
//         console.warn("Cleanup skipped — container already removed");
//       }
//     };
//   }, [embedConfig]);

//   const applyFilter = async (reportInstance) => {
//     if (!reportInstance || !projectName) return;

//     const filter = {
//       $schema: "http://powerbi.com/product/schema#basic",
//       target: { table: "T_master_project", column: "Proj_Name" },
//       operator: "In",
//       values: [projectName],
//       filterType: powerbi.models.FilterType.Basic,
//     };

//     try {
//       await reportInstance.setFilters([filter]);
//       console.log("Filter applied for:", projectName);
//     } catch (err) {
//       console.error("Error applying filter:", err);
//     }
//   };

//   return (
//     <div
//       ref={reportContainerRef}
//       style={{ height: "90vh", width: "100%", border: "1px solid #ccc" }}
//     />
//   );
// };

// export default RVWSDashboard;


